import apiClient from "./apiClient"
import type { McoEndpointBuilder } from "./apiSlice"

const userEndpoints = (build: McoEndpointBuilder) => ({
	userResetToDefaultPassword: build.mutation({
		queryFn: apiClient.user.resetToDefaultPassword
		// Does not need to invalidate tags
	}),
	userSendResetPasswordEmail: build.mutation({
		queryFn: apiClient.user.sendResetPasswordEmail
		// Does not need to invalidate tags
	})
})

export default userEndpoints
